import { SHELL, INSET_X } from '@/components/base/Frame';
import FrictionList from '@/pages/services/components/FrictionList';
import SectionLabel from '@/components/base/SectionLabel';
import { coFriction } from '@/mocks/customerOperations';
import Chapter from './Chapter';

export default function FrictionSection() {
  return (
    <Chapter id="friction">
      <div className={`${SHELL} flex flex-col py-10 md:py-14`}>
        <div className={INSET_X}>
          <SectionLabel index="02" label="Operational friction" />
          <h2 className="mt-4 text-3xl font-light leading-[1.1] tracking-[-0.02em] text-foreground-950 lg:text-[clamp(30px,2.9vw,42px)]">
            Where customer work gets stuck.
          </h2>
        </div>

        <FrictionList items={coFriction} className="mt-10 md:mt-14" />
      </div>
    </Chapter>
  );
}